module.exports = __webpack_public_path__ + "img/pic1@2x.0f5c8c2d.png";